import Http from '../http'

export const index = (page, name) => Http.get(`/sessions?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/sessions', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/sessions/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/sessions/${id}`, { headers: { Authorization: localStorage.token } })
